import * as React from "react";

import { makeStyles } from "@fluentui/react-components";

import { useAppTheme } from "hooks/useAppTheme";

// Define styles using Fluent's makeStyles
const useStyles = makeStyles({
  container: {
    position: "relative",
    width: "100%",
    height: "100%",
  },

  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateRows: "repeat(4, 1fr)",
    zIndex: 2,
    pointerEvents: "none",
  },
  tile: {
    opacity: 1,

    animationName: {
      from: {
        opacity: 1,
        transform: "scale(1)",
      },
      to: { opacity: 0, transform: "scale(0.8)" },
    },
    animationDuration: "0.6s",
    animationTimingFunction: "ease-in-out",
    animationFillMode: "forwards",
  },
});

const createDelayStyles = (rowCount: number, colCount: number): React.CSSProperties[] => {
  const tiles: React.CSSProperties[] = [];
  for (let row = 0; row < rowCount; row++) {
    for (let col = 0; col < colCount; col++) {
      const delay = `${(row + col) * 100}ms`; // checkerboard pattern
      tiles.push({ animationDelay: delay });
    }
  }
  return tiles;
};

export const CheckerboardRevealCard = ({ children }) => {
  const theme = useAppTheme();

  const styles = useStyles();
  const rowCount = 4;
  const colCount = 6;
  const delayStyles = createDelayStyles(rowCount, colCount);

  return (
    <div className={styles.container}>
      {children}

      {/* Overlay animation tiles */}
      <div className={styles.overlay}>
        {delayStyles.map((style, i) => (
          <div
            key={i}
            className={styles.tile}
            style={{ ...style, backgroundColor: theme.palette.neutralLighter }}
          />
        ))}
      </div>
    </div>
  );
};
